import { DEFAULT_CSS_CLASS } from '@constants';
import classnames from 'classnames';
import './editor.scss';

const {
  blockEditor: { useBlockProps, useInnerBlocksProps },
  element: { useEffect, useRef },
} = wp;

const BLOCKS_TEMPLATE = [
  ['core/paragraph', { placeholder: 'Accordion Floating Panel' }],
];

const changeAccordionHeightOnChange = (el) => {
  if (!el) return;
  const floatPanelElHeight = el.children[0].offsetHeight;

  const acc = el.closest('[data-accordion]');
  acc.children[0].style.minHeight = floatPanelElHeight + 'px';
};

const Edit = ({ context, setAttributes, clientId }) => {
  const { expandDefault, uniqueID } = context;
  const defaultBlockCssClass = DEFAULT_CSS_CLASS.ACCORDION;

  const floatPanel = useRef(null);

  useEffect(() => {
    const floatPanelEl = floatPanel.current;
    const onClick = () => {
      changeAccordionHeightOnChange(floatPanelEl);
    };

    floatPanelEl?.addEventListener('click', onClick);
    return () => {
      floatPanelEl?.removeEventListener('click', onClick); //NOSONAR
    };
  }, [clientId]);

  useEffect(() => {
    setAttributes({ isExpanded: expandDefault });
  }, [setAttributes, expandDefault]);

  const blockProps = useBlockProps({
    className: classnames({
      [`${defaultBlockCssClass}__flt-itm`]: true,
    }),
  });

  const innerBlocksProps = useInnerBlocksProps(blockProps, {
    template: BLOCKS_TEMPLATE,
    templateLock: false,
  });

  const fltItmWrprClasses = classnames({
    [`${defaultBlockCssClass}__flt-itm-wrpr`]: true,
    active: expandDefault,
  });

  return (
    <div
      className={fltItmWrprClasses}
      id={`float-panel-${uniqueID}`}
      data-float-panel-id={uniqueID}
      ref={floatPanel}
    >
      <div {...innerBlocksProps} />
    </div>
  );
};

export default Edit;
